import { AbstractIdbaModel } from '../abstract-idba-model';
import { ProgramaFuncao } from "./programa-funcao";


export class Acesso extends AbstractIdbaModel{

    public override convertToModel(data: any): Acesso {
        return new Acesso(data);
    }

    public override display(self: any): string {
        self.displayWith = self && self.nomePrograma ? `${self.siglaModulo} - ${self.descricaoPrograma}` : '';
        return self && self.nomePrograma ? `${self.siglaModulo} - ${self.descricaoPrograma}` : '';
    }

    public override displayCodigo(self: any): string {
        throw new Error("Method not implemented.");
    }

    public override displayNome(self: any): string {
        throw new Error("Method not implemented.");
    }

    public override filter(value: string, objectList: any[]): any[] {
        const filterValue = value.toLowerCase();
        return objectList.filter(
            (item) =>
                item.nomePrograma.trim().toLowerCase().includes(filterValue) ||
                item.descricaoPrograma.toString().toLowerCase().includes(filterValue)
        );
    }

    codigoAcesso: number;
    indInclusao: boolean;
    indAlteracao: boolean;
    indExclusao: boolean;
    indConsulta: boolean;
    indRelatorio: boolean;
    indHistorico: boolean;
    codigoUsuario: number;
    nomeUsuario: string;
    loginUsuario: string;
    codigoPrograma: number;
    nomePrograma: string;
    descricaoPrograma: string;
    funcoes: ProgramaFuncao[];
}
